import { render, staticRenderFns } from "./TabBar.vue?vue&type=template&id=063bc00a&scoped=true&"
import script from "./TabBar.vue?vue&type=script&lang=js&"
export * from "./TabBar.vue?vue&type=script&lang=js&"
import style0 from "./TabBar.vue?vue&type=style&index=0&id=063bc00a&prod&lang=css&"
import style1 from "./TabBar.vue?vue&type=style&index=1&id=063bc00a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063bc00a",
  null
  
)

export default component.exports